import axios from 'axios';

const API_URL = process.env.REACT_APP_API;

export async function getReporteVentas(id_dia: number) {
  try {
    const response = await axios.get(`${API_URL}cortesias/reporte-ventas`, {
      params: { id_dia },
    });
    return response.data?.doc?.data ?? [];
  } catch (error) {
    console.error('Error al obtener el reporte de ventas:', error);
    throw error;
  }
}
